module.exports = __webpack_public_path__ + "static/media/default_card_bg.007f7742.svg";